import { ToolbarButtonElement } from './ToolbarButtonElement'

export class ToolbarBooleanButtonElement extends ToolbarButtonElement {
  public status = false

  public override setFormat(format: { [key: string]: Set<any> }): void {
    const status = format[this.name] && format[this.name].size === 1 && format[this.name].has(true)
    if (status) {
      this.setStatus(true)
    } else {
      this.setStatus(false)
    }
  }

  protected setStatus(status: boolean): void {
    this.status = status
    if (status) {
      this.entryElement.classList.add('selected')
    } else {
      this.entryElement.classList.remove('selected')
    }
  }

  protected override initEvent() {
    this.entryElement.addEventListener('mousedown', (event) => {
      event.preventDefault()
    })
    this.entryElement.addEventListener('click', () => {
      this.emit(`click`, !this.status)
    })
  }
}
